import { type FC, useMemo } from 'react'
import styled from 'styled-components'
import { motion } from 'motion/react'
import { useSlider } from '@/hooks'
import { IS_MMF_STORE } from '@/utils'
import { getTransition, mq, vw } from '@/styles'

type Props = {
  banners: {
    titleSize: 'xl' | string,
    title: string
  }[]
}


export const SlimBanner:FC<Props> = ({ banners }) => {
  const { currentSlide } = useSlider(banners.length, true)

  const SlideData = useMemo(() => banners[currentSlide], [currentSlide, banners])
  return (
    <Aside key={'slims'} $bannerFontSize={SlideData?.titleSize} $isMmmf={IS_MMF_STORE}>
      <motion.div key={currentSlide} variants={bannerVariants} initial='inactive' animate='active' exit='exit' dangerouslySetInnerHTML={{ __html: SlideData?.title }} />
    </Aside>
  )
}

const Aside = styled.aside<{ $bannerFontSize?: 'xl' | string, $isMmmf?: boolean }>`
  height: 40px;
  background-color: var(--color-gold-background);
  position: relative;
  top: 0;
  width: 100%;
  z-index: 300;

  ${mq.greaterThan('tablet')} {
    height: ${vw(30, 'desktop')};
  }

  ${mq.greaterThan('desktop')} {
    height: 30px;
  }

  div {
    display: flex;
    align-items: center;
    height: 100%;
  }

  /* Don't use flex in the paragraph, it removes the spaces between links when comes from CMS */
  p {
    width: 100%;
  }

  a {
    text-decoration: underline;
  }

  p, a {
    font-size: ${({ $bannerFontSize }) => $bannerFontSize === 'xl' ? '14px' : '10px'};
    line-height: ${({ $bannerFontSize }) => $bannerFontSize === 'xl' ? '18px' : '14px'};
    text-align: center;
    color: ${({ $isMmmf }) => $isMmmf ? 'var(--color-red)' : 'var(--color-white)'};
    font-family: ${({ $isMmmf }) => $isMmmf ? 'var(--font-graphik)' : 'var(--font-basier-circle)'};
  }

  ~ .pdp-back-btn {
    ${mq.greaterThan('tablet')} {
      top: ${vw(200, 'desktop')};
    }
  }
`

const bannerVariants = {
  inactive: {
    y: '-10px',
    opacity: 0,
    ...getTransition()
  },
  active: {
    y: '0',
    opacity: 1,
    ...getTransition()
  },
  exit: {
    y: '10px',
    opacity: 0,
    ...getTransition()
  }
}
